import { PermissionModel } from "./Permission.model";

export class Permission extends PermissionModel {
    // Add custom methods here
}
